<template>
	<div class="platform-information-maintenance wrapper">
		<div class="content-page">
			<div class="content">
				<el-row :gutter="10">
					<el-col :span="4">
						<div class="role-box">
							<div class="box-title">平台信息维护</div>
							<ul class="box-list">
								<li :class="{ active: curPlatformInfoIndex === index }" v-for="(item, index) in platformInfoList" :key="index" @click="changePlatformInfoIndex(index)">
									{{ item }}
								</li>
							</ul>
						</div>
					</el-col>
					<el-col :span="20">
						<TopicLevelCategory v-if="curPlatformInfoIndex === 0"></TopicLevelCategory>
						<TopicPhase v-if="curPlatformInfoIndex === 1" />
						<ResearchResourceCategory v-if="curPlatformInfoIndex === 2"></ResearchResourceCategory>
						<ResearchField v-if="curPlatformInfoIndex === 5"></ResearchField>
						<JobTitle v-if="curPlatformInfoIndex === 6"></JobTitle>
						<Discipline v-if="curPlatformInfoIndex === 7"></Discipline>
						<UnitType v-if="curPlatformInfoIndex === 8"></UnitType>
						<ReviewResult v-if="curPlatformInfoIndex === 9"></ReviewResult>
						<DelayTime v-if="curPlatformInfoIndex === 10" />
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import TopicLevelCategory from './components/TopicLevelCategory.vue';
import ResearchResourceCategory from './components/ResearchResourceCategory.vue';
import JobTitle from './components/JobTitle.vue';
import ResearchField from './components/ResearchField.vue';
import Discipline from './components/Discipline.vue';
import UnitType from './components/UnitType.vue';
import TopicPhase from './components/TopicPhase.vue';
import ReviewResult from './components/ReviewResult.vue'
import DelayTime from './components/DelayTime.vue'
export default {
	components: {
		TopicLevelCategory,
		ResearchResourceCategory,
		JobTitle,
		ResearchField,
		Discipline,
		UnitType,
		TopicPhase,
		ReviewResult,
		DelayTime
	},
	data() {
		return {
			platformInfoList: ['课题级别类别', '课题阶段', '科研资源类别', '论文类别', '成果类别', '研究领域', '职称', '学科管理','单位类型','评审结果','延期时间'],
			curPlatformInfoIndex: 10,
			params: {
				pageNumber: 1,
				pageSize: 100,
				pageSorts: [
					{
						asc: true,
						column: ''
					}
				]
			}
		};
	},
	created() {},
	methods: {
		// 切换平台列表索引
		changePlatformInfoIndex(index) {
			this.curPlatformInfoIndex = index;
		}
	}
};
</script>

<style scoped lang="scss">
.btn-wrap {
	margin-top: 20px;
}
.role-box {
	background-color: #fff;
	box-shadow: 0px 0px 8px #eeeeee;
	.box-title {
		line-height: 50px;
		font-size: 14px;
		text-align: center;
		border-bottom: 2px solid #e3eaef;
	}
	.box-list {
		list-style: none;
		padding: 0;
		color: #000;
		li {
			padding-left: 20%;
			cursor: pointer;
			line-height: 40px;
		}
		li.active,
		li:hover {
			line-height: 40px;
			background-color: #99aee2;
		}
	}
}
</style>
